import { Form, Space, Tabs } from "antd"
import { useMemo, useState } from "react"
import Styles from "./styles.module.css"

import { GameCard } from "../gameCard"
import { useStore } from "stores/utils/use-store"
import { getSpecialEventPresetsConfig } from "domains/specialEvents/presets"
import {
  SpecialEventsAssetsPanel,
  SpecialEventsOverview,
  SpecialEventsPixelsPanel,
} from "../specialEventsAutomation"

type Props = {
  contestMode?: boolean
  activeTab?: string
  onActiveTabChange?: (key: string) => void
}

export const GamesEditor = ({ contestMode, activeTab: controlledTab, onActiveTabChange }: Props) => {
  const [ownTab, setOwnTab] = useState("overview")
  const activeTab = controlledTab ?? ownTab
  const setActiveTab = onActiveTabChange ?? setOwnTab
  const { dataStore: { managingJsonStore } } = useStore()
  const presetsConfig = useMemo(
    () => getSpecialEventPresetsConfig(managingJsonStore.itemTypes),
    [managingJsonStore.itemTypes],
  )

  return (
    <Form.List name="notificationsPerGame">
      {fields => (
        <Space direction="vertical" size="large" className={Styles.wrapper}>
          {contestMode ? (
            fields.map(({ key, name: index }) => (
              <GameCard key={key} index={index} contestMode={contestMode} />
            ))
          ) : (
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={[
                {
                  key: "overview",
                  label: "Overview",
                  children: <SpecialEventsOverview presetsConfig={presetsConfig} onOpenEvents={() => setActiveTab("events")} />,
                },
                {
                  key: "events",
                  label: "Game events",
                  children: (
                    <Space direction="vertical" size="large" className={Styles.wrapper}>
                      {fields.map(({ key, name: index }) => (
                        <GameCard key={key} index={index} contestMode={contestMode} presetsConfig={presetsConfig} />
                      ))}
                    </Space>
                  ),
                },
                {
                  key: "assets",
                  label: "Assets",
                  children: <SpecialEventsAssetsPanel presetsConfig={presetsConfig} />,
                },
                {
                  key: "pixels",
                  label: "Pixels",
                  children: <SpecialEventsPixelsPanel presetsConfig={presetsConfig} />,
                },
              ]}
            />
          )}
        </Space>
      )}
    </Form.List>
  )
}
